// extracted by mini-css-extract-plugin
module.exports = {"LPTransition":"style_LPTransition__3R3Tu","noScrollbar":"style_noScrollbar__1fOae","sideUpper":"style_sideUpper__lExrG","btnIcon":"style_btnIcon__2BWSt"};